// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 2109687831
import { createAction } from 'typesafe-actions';

import type { FilterState } from 'state/filters/types';

export const setFilters = createAction('FILTERS/SET_FILTERS')<{
  key: keyof FilterState;
  filters: any;
}>();
